import { Skelton } from 'library/skelton';
import ProgressGPTContainer from '../ProgressGPTContainer/ProgressGPTContainer';

const ChatRepliesLoading = () => {
    const botIndexes = [1, 3, 5, 7];

    return (
        <ProgressGPTContainer className="space-y-3 pt-6 pb-6">
            {Array.from(Array(4).keys()).map((r, i) => (
                <div key={r}>
                    {botIndexes.includes(i) ? (
                        <div className="flex gap-3">
                            {/* <div className="relative flex flex-col items-center mt-1">
                                    <Skelton variant="circular" width="20px" height="20px" />
                                </div> */}

                            <div className="flex-1">
                                <Skelton width="70%" />
                                <Skelton width="60%" />
                                <Skelton width="60%" />
                            </div>
                        </div>
                    ) : (
                        <div className="flex justify-end gap-4">
                            <div className="flex-1 flex flex-col items-end ml-auto">
                                <Skelton width="70%" />
                                <Skelton width="60%" />
                            </div>
                        </div>
                    )}
                </div>
            ))}
        </ProgressGPTContainer>
    );
};

export default ChatRepliesLoading;
